const state = {
  isOngoing: false,
  showUI: false,
  status: null,
  currentInventoryID: null,
  confirmadas: [],
  highLightedRows: [],
};

const getters = {
  inventoryStatus: state => state.status,
  isInventoryReviewActive: state => state.isOngoing,
  showInventoryUI: state => state.showUI,
  inventarioID: state => state.currentInventoryID,
  existenciasConfirmadas: state => state.confirmadas,
  itemRowsToHighlight: state => state.highLightedRows,
};

const actions = {
  startInventoryReview: ({ commit }) => {
    commit('setInventoryStatus', 'started');
  },
  stopInventoryReview: ({ commit }) => {
    commit('setInventoryStatus', 'done');
  },
  toggleInventoryUI: ({ commit }, payload) => {
    commit('setInventoryUIShowState', payload);
  },
  createInventory: ({ commit }, id) => {
    commit('setInventoryID', id);
  },
  resetInventoryID: ({ commit }) => {
    commit('setInventoryID', null);
  },
  addConfirmedItem: ({ commit }, confirmedItem) => {
    commit('addConfirmedInventoryItem', confirmedItem);
  },
  resetConfirmedItems: ({ commit }) => {
    commit('setConfirmadas', []);
  },
  addHighLightRow: ({ commit }, row) => {
    commit('addRow', row);
  },
  resetHiglihtRows: ({ commit }) => {
    commit('setHiglightList', []);
  },
  resetInventoryStatus: ({ commit }) => {
    commit('setInventoryStatus', null);
  },
};

const mutations = {

  setInventoryStatus: (state, value) => {
    state.status = value;
    switch (value) {
      case 'started':
        state.isOngoing = true;
        break;
      case 'done':
      case null:
        state.isOngoing = false;
        break;
      default:
        break;
    }

  },
  setInventoryUIShowState: (state, value) => {
    state.showUI = value;
  },
  setInventoryID: (state, id) => {
    state.currentInventoryID = id;
  },
  addConfirmedInventoryItem: (state, confimedItem) => {
    state.confirmadas = [...state.confirmadas, confimedItem];
  },
  setConfirmadas: (state, payload) => {
    state.confirmadas = payload;
  },
  addRow: (state, row) => {
    state.highLightedRows = [...state.highLightedRows, row];
  },
  setHiglightList: (state, payload) => {
    state.highLightedRows = payload;
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};